module.exports = __webpack_public_path__ + "static/media/ressence.4c007de6.jpg";